import React, { useState, useEffect } from 'react';
import { QuizForm } from './QuizForm'
import { ExistingQuizzes } from './includes/ExistingQuizzes';
import { fetchQuizzes } from './api/index'
import s from './CreateQuiz.module.scss'
import { hideWidget, loadWidget } from '../../lib/widget-loader';
import { useSelector, shallowEqual } from 'react-redux';
const Quizzes = () => {
	const [showCreateQuiz, setShowCreateQuiz] = useState(false);
	const [quizToEdit, setQuizToEdit] = useState(null);
	const [allQuizzes, setAllQuizzes] = useState([]);
	const [archivedQuizzes, setArchivedQuizzes] = useState([]);
	const [activeQuizzes, setActiveQuizzes] = useState([]);
	const [quizzesToShow, setQuizzesToShow] = useState([]);
	const [activeButton, setActiveButton] = useState(0);
	const createQuiz = () => {
		setShowCreateQuiz(true)
	}

	const { merchantId, merchants } = useSelector(
		(state) => ({
			merchants: state.merchants.merchants,
			merchantId: state.merchants.filter.merchantId,
		}),
		shallowEqual
	);
	function enterEditingMode(quiz) {
		setShowCreateQuiz(true)
		setQuizToEdit(quiz)
	}
	function isQuizActive(quiz) {
		return quiz.to >= new Date().getTime() && quiz.from <= new Date().getTime()
	}
	function isQuizArchived(quiz) {
		return quiz.to <= new Date().getTime() || quiz.from >= new Date().getTime()
	}
	async function fetch(merchantId) {
		const quizzes = await fetchQuizzes({ merchantId });
		setArchivedQuizzes(quizzes?.filter(quiz => isQuizArchived(quiz)));
		setActiveQuizzes(quizzes?.filter(quiz => isQuizActive(quiz)));
		setAllQuizzes(quizzes);
		setQuizzes(quizzes, 0);
	}
	useEffect(() => {
		const merchant = merchants.find(m => m.merchantId === merchantId);

		if (!merchant || !merchantId) {
			return;
		}
		loadWidget(merchantId);
		fetch(merchantId);
		return function cleanup() {
			hideWidget();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [merchantId, merchants]);

	const filterButtons = [
		{
			text: 'All',
			quizzes: allQuizzes,
		},
		{
			text: 'Active',
			quizzes: activeQuizzes,
		},
		{
			text: 'Archived',
			quizzes: archivedQuizzes,
		},
	]
	function setQuizzes(quizzes, buttonIndex) {
		setQuizzesToShow(quizzes)
		setActiveButton(buttonIndex)
	}
	return (
		<>
			{showCreateQuiz ?
				<QuizForm fetch={fetch} setShowCreateQuiz={setShowCreateQuiz} quizToEdit={quizToEdit} setQuizToEdit={setQuizToEdit} />
				:
				<div className={`page-wrapper flex-wrap ${s.emptyContentContainer}`}>
					<div>
						<h1>Quizzes</h1>
						<div className={s.quizButtons}>
							{filterButtons.map((quizButton, index) =>
								<React.Fragment key={quizButton.text}>
									<button
										key={quizButton.text}
										className={`btn ${s.quizButton}`}
										style={{ fontWeight: activeButton === index ? 'bold' : 'normal' }}
										onClick={() => setQuizzes(quizButton.quizzes, index)}>
										{quizButton.text}
									</button>
								</React.Fragment>
							)}
						</div>
						<div style={{ display: 'flex', gridGap: '24px' }}>
							{quizzesToShow && quizzesToShow.length ?
								quizzesToShow.map(quiz => <ExistingQuizzes isQuizArchived={isQuizArchived} key={quiz._id} quiz={quiz} enterEditingMode={enterEditingMode} />)
								: null}
						</div>
					</div>
					<div>
						<button onClick={createQuiz} className="btn btn-primary">
							+ Create A New Quiz
						</button>
					</div>
				</div>
			}
		</>
	);
};
export default Quizzes;
